import { apiGetJSON } from "../../client.js";
import { requestsCurrent } from "../../core/request-coordinator.js";

export const MAX_LLM_CONTEXT_ITEM_REFS = 32;

export function canReadContextItemsPermission(permissions) {
  const permission = contextPermission(permissions, "contextItems");
  return permission === "read" || permission === "write";
}

export async function loadLLMThreadContextItems(state, apiKey, options = {}) {
  const threadID = String(state?.thread?.id || "").trim();
  if (!apiKey || !threadID || !canReadContextItemsPermission(options.contextPermissions)) {
    return false;
  }
  if (!options.force && state.contextItemsLoadedThreadID === threadID) {
    options.render?.();
    return false;
  }
  state.contextItemsLoading = true;
  state.contextItemsError = "";
  options.render?.();
  try {
    const response = await apiGetJSON(apiKey, `/v1/threads/${encodeURIComponent(threadID)}/context-items`, {
      signal: options.signal
    });
    if (!requestsCurrent(options.request, options.parentRequest)) {
      return false;
    }
    state.contextItems = Array.isArray(response?.items) ? response.items : [];
    state.contextItemsLoadedThreadID = threadID;
    return true;
  } catch (error) {
    if (!requestsCurrent(options.request, options.parentRequest)) {
      return false;
    }
    state.contextItemsError = error.message || "Unable to load context.";
    options.setStatus?.(state.contextItemsError, "error");
    return false;
  } finally {
    if (requestsCurrent(options.request, options.parentRequest)) {
      state.contextItemsLoading = false;
      options.render?.();
    }
  }
}

export function filterLLMContextItems(items, filterText) {
  const query = String(filterText || "").trim().toLowerCase();
  if (!query) {
    return Array.isArray(items) ? items : [];
  }
  return (Array.isArray(items) ? items : []).filter((item) => contextItemSearchText(item).includes(query));
}

function contextPermission(permissions, key) {
  if (!permissions) {
    return "write";
  }
  return String(permissions[key] || "").trim().toLowerCase() || "none";
}

function contextItemSearchText(item) {
  return [
    item?.id,
    item?.title,
    item?.filename,
    item?.source_id,
    item?.source_path,
    item?.content_type,
    item?.text_preview,
    item?.text
  ].map((value) => String(value || "").toLowerCase()).join("\n");
}
